export default "__VITE_ASSET__7f0fR9dK__"